import React, { useEffect, useState, useRef } from 'react';
import Compressor from 'compressorjs';
import NoAvatar from '@assets/images/no-avatar.png';
import { ApiResponse } from '@typings/ApiResponse';
import uploadFile from '@api/upload-file';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

interface UploadImageProps {
  isEditable: boolean;
  isCustomized: boolean;
  title: string;
  imageUrl: string;
  setImageUrl: (avatar: string) => void;
}

const UploadImage: React.FC<UploadImageProps> = ({
  isEditable,
  isCustomized,
  title,
  imageUrl,
  setImageUrl,
}) => {
  const [displayingAvatar, setDisplayingAvatar] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setIsUploading(true);
      new Compressor(file, {
        quality: 0.6,
        success: async (compressedResult: any) => {
          const formData = new FormData();
          formData.append('files', compressedResult, compressedResult.name);
          try {
            const response: ApiResponse<string> = await uploadFile(
              'image',
              formData
            );
            if (response && response.status === 'success') {
              const url = response.data;
              setDisplayingAvatar(url);
              setImageUrl(url);
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsUploading(false);
          }
        },
      });
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  useEffect(() => {
    setDisplayingAvatar(imageUrl);
  }, [imageUrl]);

  return (
    <div className="upload-img w-fit">
      {displayingAvatar ? (
        <img
          src={displayingAvatar}
          width="300"
          height="300"
          className="profile-img"
          alt={displayingAvatar}
        />
      ) : (
        <img
          width="300"
          height="300"
          className="profile-img"
          src={NoAvatar}
          alt="No Avatar"
        />
      )}

      {isEditable && (
        <div className="govuk-form-group mt-3 w-full">
          <label className="govuk-label">{title}</label>
          {isCustomized && (
            <button
              type="submit"
              className="govuk-button govuk-button--secondary govuk-!-width-full govuk-!-margin-0"
              data-module="govuk-button"
              onClick={handleButtonClick}
              disabled={isUploading}
            >
              Upload a photo
            </button>
          )}

          <input
            ref={fileInputRef}
            className="govuk-file-upload"
            id="upload-photo"
            name="fileUpload1"
            type="file"
            accept=".jpeg,.jpg,.png,.gif,.svg"
            onChange={handleFileUpload}
            disabled={isUploading}
            hidden={isCustomized}
          />
        </div>
      )}
    </div>
  );
};

export default UploadImage;
